import React, { useRef } from 'react';
import styles from '../FileSelect.module.css';
import { FaUpload } from 'react-icons/fa';

export default function SelectPrompt({
  fileTypes,
  onUpdateFile = () => {},
  onFileDrop = () => {},
}) {
  const inputRef = useRef(null);

  const openDialog = () => inputRef.current?.click();

  return (
    <div
      className="flex-fill align-self-stretch d-flex justify-content-center align-items-center px-5"
      onDragOver={(e) => e.preventDefault()}
      onDrop={onFileDrop}
    >
      <div className="d-flex flex-column justify-content-center text-center">
        <p>Drop file here to begin uploading</p>
        <p>or</p>
        <button
          className="d-flex justify-content-center align-items-baseline gap-2 btn bg-primary-shadow"
          onClick={openDialog}
        >
          <FaUpload />
          <p className="m-0">Select File</p>
        </button>
      </div>

      <input
        ref={inputRef}
        className="d-none"
        type="file"
        accept={fileTypes?.join(',')}
        onChange={onUpdateFile}
      />
    </div>
  );
}
